function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import PropTypes from 'prop-types';
import Icon from "../../Icon/Icon";
import Phones from "../../../utils/Phones";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const PhoneNumbers = _ref => {
  let {
    phone_numbers = [],
    hideLabels = false,
    isInNetworkGroup = true,
    sortOrder = ['work', 'mobile', 'home', 'phone', 'fax', 'other', 'unknown'],
    detailedExtension = false
  } = _ref;
  const phoneNumbers = Phones.sortPhoneNumbers(phone_numbers, sortOrder);
  return phoneNumbers.map(phoneNumber => {
    const {
      extension = '',
      phone_type = '',
      phone_number = ''
    } = phoneNumber;
    const capitalized_phone_type = phone_type ? phone_type[0].toUpperCase() + phone_type.slice(1) : '';
    let numberText = !hideLabels && capitalized_phone_type ? "".concat(capitalized_phone_type, ": ") : '';
    numberText += Phones.formatPhoneNumber(extension ? phone_number + extension : phone_number, detailedExtension);
    return /*#__PURE__*/_jsx("div", {
      className: "mb-1",
      children: /*#__PURE__*/_jsxs("a", {
        href: Phones.getTelLink(phoneNumber, detailedExtension),
        target: "_blank",
        tabIndex: 0,
        rel: "noopener noreferrer",
        className: "rounded-sm focus:outline-solid-offset",
        title: numberText,
        children: [/*#__PURE__*/_jsx(Icon, {
          className: "align-middle",
          color: "".concat(isInNetworkGroup ? 'action-blue' : 'brand-blue'),
          icon: "Phone"
        }), /*#__PURE__*/_jsx("span", _objectSpread(_objectSpread({
          className: "align-middle pl-1 normal-case"
        }, detailedExtension && {
          'data-test-element': 'client_phone_number'
        }), {}, {
          children: numberText
        }))]
      })
    }, "phone-".concat(phone_number));
  });
};
PhoneNumbers.propTypes = {
  hideLabels: PropTypes.bool,
  isInNetworkGroup: PropTypes.bool,
  phone_numbers: PropTypes.array.isRequired,
  sortOrder: PropTypes.array,
  detailedExtension: PropTypes.bool
};
export default PhoneNumbers;
//# sourceMappingURL=PhoneNumbers.js.map